import * as Cookie from './cookie';

export const VerificarUsuario = () => {
    if (Cookie.LeerCookie('cookieLogin') != '') {
        MostrarUsuario();
    }
}

export const Salir = () => {
    $('#cabezal').removeClass('logueado');
    $('#cabezal').removeClass('suscripto');
    return OcultarUsuario();
}

function MostrarUsuario() {

    var nick = Cookie.LeerCookie('usuario%5Fdetalle%5Fnick');

    $('.usuario').text(nick + ' ' + $('.usuario').text());

    $('.ingresar').css('display', 'none');
    //$('.usuario').css('display', 'initial');

    if (Cookie.LeerCookie('ProductoPremiumId') != ""){
        $('#cabezal').addClass('suscripto');
    }
    else{
        $('#cabezal').addClass('logueado');
    }

}

function OcultarUsuario() {
    $('.ingresar').css('display', 'initial');
    $('.usuario').css('display', 'none');

    $('.usuario').text('&#9660;');

    localStorage.removeItem("token");

    window.top.frames['iLogout'].location.href = window.config.Statics.SitioSeguroRegistracion + '/logout/logout.html?pagina=' + window.location.origin + window.config.Statics.LogoutUrl;

    if (typeof fyre != "undefined") {
        fyre.conv.logout();
    }

    return false;
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/usuario.js